class NotifyMeForm {
  constructor(formEl) {
    this.form = formEl;
    this.productId = formEl.closest('[data-product-id]').dataset.productId;
    this.variantId = formEl.closest('[data-variant-id]').dataset.variantId;
    this.wrapper = formEl.closest('.notify-me-wrapper');
    this.successEl = this.wrapper.querySelector('.notify-me-success');
    this.errorEl = this.wrapper.querySelector('.notify-me-error');
    this.btn = this.wrapper.querySelector('.notify-me-btn');

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  setLoading(isLoading) {
    this.btn.classList.toggle('is-loading', isLoading);
    this.btn.disabled = isLoading;
  }

  showError(msg) {
    this.errorEl.textContent = msg;
    this.errorEl.classList.add('is-visible');
  }

  clearError() {
    this.errorEl.textContent = '';
    this.errorEl.classList.remove('is-visible');
  }

  showSuccess() {
    this.form.hidden = true;
    this.successEl.hidden = false;
    this.successEl.classList.add('is-visible');
  }

  isDuplicate(email) {
    const stored = JSON.parse(localStorage.getItem('notify_me_signups') || '{}');
    const key = `${this.productId}_${this.variantId}`;
    return stored[key] && stored[key].includes(email.toLowerCase());
  }

  saveLocal(email) {
    const stored = JSON.parse(localStorage.getItem('notify_me_signups') || '{}');
    const key = `${this.productId}_${this.variantId}`;
    if (!stored[key]) stored[key] = [];
    stored[key].push(email.toLowerCase());
    localStorage.setItem('notify_me_signups', JSON.stringify(stored));
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.clearError();

    const emailInput = this.form.querySelector('[name="email"]');
    const email = emailInput.value.trim();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.showError('Please enter a valid email address.');
      emailInput.focus();
      return;
    }

    if (this.isDuplicate(email)) {
      this.showError("You're already on the waitlist for this product.");
      return;
    }

    this.setLoading(true);

    try {
      const productTitle = this.wrapper.querySelector('[name="product_title"]')?.value || '';
      const variantTitle = this.wrapper.querySelector('[name="variant_title"]')?.value || '';
      const variantId = this.wrapper.dataset.variantId || this.variantId;

      // Usar iframe + form para evitar CORS con Zapier
      const iframe = document.createElement('iframe');
      iframe.name = 'zapier-frame';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      const zapForm = document.createElement('form');
      zapForm.method = 'POST';
      zapForm.action = 'https://hooks.zapier.com/hooks/catch/20339817/u0mq419/';
      zapForm.target = 'zapier-frame';

      const fields = {
        email,
        productId: this.productId,
        variantId,
        productTitle,
        variantTitle
      };

      Object.entries(fields).forEach(([key, val]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = val;
        zapForm.appendChild(input);
      });

      document.body.appendChild(zapForm);
      zapForm.submit();

      setTimeout(() => {
        document.body.removeChild(zapForm);
        document.body.removeChild(iframe);
      }, 3000);

      this.saveLocal(email);
      this.showSuccess();

    } catch (err) {
      console.error('[NotifyMe]', err);
      this.showError(err.message || 'Something went wrong. Please try again.');
    } finally {
      this.setLoading(false);
    }
  }
}

// Sincronizar el form con el estado del market
// window.__bonnellNotifyShow es el flag que setea variant-availability-logic.liquid
// Si el flag está definido, tiene prioridad sobre la lectura del badge
function syncNotifyForm(variantId) {
  const wrapper = document.querySelector('.notify-me-wrapper');
  if (!wrapper) return;

  // Si el sistema market-aware ya tomó control, respetar su decisión
  if (typeof window.__bonnellNotifyShow !== 'undefined') {
    if (window.__bonnellNotifyShow) {
      wrapper.style.setProperty('display', 'flex', 'important');
      if (variantId) {
        const hiddenVariant = wrapper.querySelector('[name="variant_id"]');
        if (hiddenVariant) hiddenVariant.value = variantId;
        wrapper.dataset.variantId = variantId;
      }
    } else {
      wrapper.style.setProperty('display', 'none', 'important');
    }
    return;
  }

  // Fallback original: leer el badge si el flag no está disponible
  const badge = document.getElementById('availability-badge');
  if (!badge) return;

  const badgeText = badge.textContent.toLowerCase().trim();
  const showForm = badgeText.includes('arriving soon') || badgeText.includes('out of stock') || badgeText.includes('sold out');

  if (showForm) {
    wrapper.style.setProperty('display', 'flex', 'important');
    if (variantId) {
      const hiddenVariant = wrapper.querySelector('[name="variant_id"]');
      if (hiddenVariant) hiddenVariant.value = variantId;
      wrapper.dataset.variantId = variantId;
    }
  } else {
    wrapper.style.setProperty('display', 'none', 'important');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Mover al portal si existe
  const portal = document.getElementById('notify-me-portal');
  const wrapper = document.querySelector('.notify-me-wrapper');
  if (portal && wrapper) portal.appendChild(wrapper);

  // Sync inicial — esperar a que el availability script cargue primero
  const initialVariantId = new URLSearchParams(window.location.search).get('variant');
  setTimeout(() => syncNotifyForm(initialVariantId), 900);

  // Polling de URL cada 500ms
  let lastUrl = location.href;
  setInterval(() => {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      const variantId = new URLSearchParams(window.location.search).get('variant');
      setTimeout(() => syncNotifyForm(variantId), 900);
    }
  }, 500);
});

// Inicializar formularios
document.querySelectorAll('.notify-me-form').forEach((el) => {
  new NotifyMeForm(el);
});